import MlxButton from '../../../../../../components/common/MlxButton/MlxButton';
import { JTranslation } from '../../../../../../helpers/jTranslationHelper';
import {
    MENU_IMPORT_FAILED_DESC,
    MENU_IMPORT_FAILED_TITLE,
    MENU_IMPORT_TRY_AGAIN,
    MENU_IMPORT_UPLOAD_DIFFERENT,
} from '../../../../../../constants/strings';

type _FailedStepProps = {
    onTryAgain: () => void;
    onUploadDifferent: () => void;
    busy?: boolean;
};

const FailedStep = ({ onTryAgain, onUploadDifferent, busy = false }: Readonly<_FailedStepProps>) => (
    <div className="bulk-upload-card bulk-upload-state">
        <div className="bulk-upload-state-heading">
            <i className="ri-error-warning-line bulk-upload-state-error-icon" aria-hidden="true" />
            <span className="bulk-upload-state-title">
                <JTranslation text={MENU_IMPORT_FAILED_TITLE} />
            </span>
        </div>
        <span className="bulk-upload-muted">
            <JTranslation text={MENU_IMPORT_FAILED_DESC} />
        </span>
        <div className="bulk-upload-actions">
            <MlxButton outlined disabled={busy} onClick={onUploadDifferent}>
                <JTranslation text={MENU_IMPORT_UPLOAD_DIFFERENT} />
            </MlxButton>
            <MlxButton disabled={busy} onClick={onTryAgain}>
                <JTranslation text={MENU_IMPORT_TRY_AGAIN} />
            </MlxButton>
        </div>
    </div>
);

export default FailedStep;
